export default function () {
  return {
    errors: {},
    success: false,
    error: false,
    setting: {
      name: '',
      label: '',
      value: null,
      type: '',
    }
  }
}
